import React from 'react';

class Home extends React.Component {
    render() {
      return (
        <section className="panel no-padding">
          <img style={{width:'100%'}} src={require('../../assets/images/homebg.webp')} width='100%' height='100%' alt='homebg' />
        </section>
      );
    }
  }

  export default Home;